module.exports = __webpack_public_path__ + "img/solution_courseMindMap.9e80c72b.png";